var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"tools"}},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"main"},[_c('div',{staticClass:"tools-content"},[_c('router-view')],1)])])])
}
var staticRenderFns = []

export { render, staticRenderFns }